export default class templateBlockSettings {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/template/template-block-settings.html'),
            controller: TemplateBlockCtrl,
            controllerAs: 'block'
        }
    }
};

class TemplateBlockCtrl {
    constructor($rootScope, $element) {
        this._rootScope = $rootScope;

        this.settings = {};
        this.fonts = [
            { name: 'Arial', value: "Arial,'Helvetica Neue',Helvetica,sans-serif" },
            { name: 'Trebuchet', value: "'Trebuchet MS','Lucida Grande','Lucida Sans Unicode','Lucida Sans',Tahoma,sans-serif" },
            { name: 'Calibri', value: "Calibri,Candara,Segoe,'Segoe UI',Optima,Arial,sans-serif" },
            { name: 'Times', value: "TimesNewRoman,'Times New Roman',Times,Baskerville,Georgia,serif" },
            { name: 'Dyslexi-typsnitt', value: 'open-dyslexic' },
            { name: 'Courier New', value: "'Courier New',Courier,'Lucida Sans Typewriter','Lucida Typewriter',monospace" }
        ];

        this.selectedFont = this.fonts[0];

        let colorPicker = $element.find('input');
        colorPicker.spectrum();

        this._scope.$watch('color', (newVal, oldVal) => {
            if (newVal != oldVal) {
                if (this.currentElement) {
                    this.currentElement.style.backgroundColor = newVal;
                }
            }
        });

        this._scope.$watch('selectedFont', (newVal, oldVal) => {
            if (oldVal != newVal) {
                this.setGlobalFont(newVal);
            }
        });

        this._scope.$on('template:block:selected', (event, element) => {
            this.currentElement = element;
        });
    }


    setFont(font) {
        this.selectedFont = font;
        this.settings.font_family = font.value;
    };

    setGlobalFont(font) {
        let siblings = angular.element('#mail-editor').find('.iguana');
        angular.forEach(siblings, (sibling) => {
            sibling.style.setProperty('font-family', this.selectedFont.value);
        });
    };
}